import { Component, Input, OnInit, OnChanges, SimpleChanges, Inject } from '@angular/core';
import { downgradeToAJSComponent } from 'ib-web-commons/utils';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { UpgradeModule } from '@angular/upgrade/static';
import { NgReactModule } from '@src/app/react/ng-react.module';
import { AJSGiftCardsCommonsSessionStorageService, GiftCardsCommonsSessionStorageServiceType } from '@shared/services/upgrades/ib-gift-cards-commons-session-storage-bridge.service';
import { GiftCardTheme } from '@src/app/core/models/campaigns.model';
import { CampaignsService } from '@src/app/shared/services/ib-gift-cards-campaigns/ib-gift-cards-campaigns.service';


@Component({
    standalone: true,
    imports: [CommonModule, UpgradeModule, TranslateModule, NgReactModule],
    selector: 'ib-gift-cards-card-selected-component',
    templateUrl: './ib-gift-cards-card-selected-component-view.html'
})


export class ibGiftCardsCardSelectedComponent implements OnInit, OnChanges { 
    @Input() model;
    @Input() theme;
    @Input() show;
    @Input() message;
    protected viewModel: GiftCardTheme;

    constructor (
        private translateService: TranslateService,
        private CampaignsService: CampaignsService,
        @Inject(AJSGiftCardsCommonsSessionStorageService) private CommonsSessionStorageService: GiftCardsCommonsSessionStorageServiceType
    ) {}

    ngOnInit (): void {
        const defaultCard = 'GIFT';
        this.onThemeChanged(defaultCard);
    }

    ngOnChanges (changes: SimpleChanges): void {
        if (changes['theme'] && !changes['theme'].firstChange) {
            this.onThemeChanged(changes['theme'].currentValue);
        }
    }

    onThemeChanged (newTheme: string): void {
        this.CampaignsService.buildCardViewModel(newTheme)
            .then(viewModel => {
                this.viewModel = viewModel;
            });
    }


    
}

downgradeToAJSComponent('ibGiftCardsCardSelectedComponent', {
    component: ibGiftCardsCardSelectedComponent,
    inputs: []
}, 'ib-gift-cards-component');
